import React, { useContext } from "react";
import { TitleText, TitleWrapper, StyledButton } from "../../../shared/styled/TitleBar";
import { TitleBar } from "../../../configs/employee";
import { useNavigate } from "react-router-dom";
import AddIcon from "../../../shared/svg/AddIcon";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";

const Title = () => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreate = [ROLE.MANAGER].includes(role);

    const onClickCreateUser = () => {
        navigate("/users/create");
    };

    return (
        <TitleWrapper>
            <TitleText> {TitleBar.title} </TitleText>
            {canCreate && (
                <StyledButton variant="contained" onClick={onClickCreateUser}>
                    <AddIcon />
                    Tạo mới nhân viên
                </StyledButton>
            )}
        </TitleWrapper>
    );
};

export default Title;
